import { ref, computed } from "vue";
import { useToast } from "vue-toastification"

import store from "../state/store"


export default function useOurTeam(props, emit, team) {

    // Get toast interface
    const toast = useToast()

    const loading = ref(false)
    const errors = ref({})


    const show = computed({
        get: () => props.modelValue,
        set: (value) => emit("update:modelValue", value),
    })

    const getTeamMembers = () => {
        store.dispatch("getTeamMembers")
    }

    const onSubmit = () => {
        loading.value = true

        if (team.value.id) {
            store.dispatch('updateTeam', team.value)
                .then(response => {
                    loading.value = false;
                    if (response.status === 200) {
                        toast.success("Der Dienst wurde erfolgreich aktualisiert!", {
                            timeout: 3000,
                        })
                        store.dispatch("getTeamMembers")
                        closeModal()
                    }
                })
                .catch((err) => {
                    loading.value = false
                    errors.value = err.response.data.errors
                })

        } else {

            store
                .dispatch("createTeam", team.value)
                .then((response) => {
                    loading.value = false
                    if (response.status === 201) {
                        toast.success("Dienst erfolgreich hinzugefügt!", {
                            timeout: 3000,
                        })
                        store.dispatch("getTeamMembers")
                        closeModal()
                    }
                })
                .catch((err) => {
                    loading.value = false
                    errors.value = err.response.data.errors
                })
        }

    }

    const closeModal = () => {
        show.value = false
        errors.value = {}
        team.value.team_image = null
        emit("close")
    }


    return {
        show,
        loading,
        errors,
        getTeamMembers,
        onSubmit,
        closeModal,
    }
}